import BaseModel from './BaseModel'

export default class Location extends BaseModel {
  // ... Location-specific methods or overrides ...
}
